var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.ActiveRenderComponent)?_c(_vm.ActiveRenderComponent,{tag:"component",attrs:{"System":_vm.System,"SystemEntities":_vm.SystemEntities,"TeamView":_vm.TeamView,"MyActivitiesArray":_vm.MyActivitiesArray,"UnreadNotifications":_vm.UnreadNotifications,"LineGraph":true,"Color":_vm.col.Color}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }